module.exports = __webpack_public_path__ + "images/slide2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slide2.png
// module id = 1135
// module chunks = 0